import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";

const Template = (data) => {
    return html` <div class="ux-row">
        <div
            class="ux-col-12 ux-col-md-10 ux-u-offset-md-1 ux-col-lg-8 ux-u-offset-lg-2 ux-u-text-align--center ux-u-my-fluid-xs ux-iws-headline-in-module"
        >
            <h1 class="ux-text-headline ux-text-headline--giant">
                ${data.headline}
            </h1>
            ${data.text
                ? html`<p class="ux-text-normal ux-u-mb-zero">
                      ${data.text}
                  </p>`
                : ""}
        </div>
    </div>`;
};

export default {
    title: "MyTrumpf/Partial Templates/Page Intro",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
};

export const Default = Template.bind({});
Default.args = {
    headline: "Page Intro Headline",
    text:
        "Page Intro Text Content Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.",
};
